import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const saveQurbaniStep = createAsyncThunk(
    'qurbani/saveStep',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/save-step', payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to save step');
        }
    },
);


export const fetchQurbaniProducts = createAsyncThunk(
    'qurbani/fetchProducts',
    async (farmId = 0, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/products/', {
                params: {
                    product_type: 'qurbani',
                    order_sub_type_id: farmId || 0,
                    visibility_info: 0,
                },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch products');
        }
    },
);


export const fetchQurbaniInformation = createAsyncThunk(
    'qurbani/fetchInformation',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/qurbani/information');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch qurbani information');
        }
    },
);

export const fetchQurbaniCart = createAsyncThunk(
    'qurbani/fetchCart',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/qurbani/cart');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch cart');
        }
    },
);

export const emptyQurbaniCart = createAsyncThunk(
    'qurbani/emptyCart',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/qurbani/cart/empty');
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to empty qurbani cart');
        }
    },
);

export const placeQurbaniOrder = createAsyncThunk(
    'qurbani/placeOrder',
    async (extraPayload = {}, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const userId = state.auth?.userInfo?.user_id;
            const platformType = localStorage.getItem('isMobileApp') === 'true' ? 'mobile' : 'web';
            const payload = {
                action: 'place-order',
                order_type: 'qurbani',
                user_id: String(userId || ''),
                platform_type: platformType,
                ...extraPayload
            };
            const { data } = await axiosInstance.post('/checkout/place-order', payload);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Failed to place order');
        }
    },
);